import { TableDefine } from '@/libs/tableHelper/type'
import { Donation } from '@/api/donation/Donation'
import { CreateElement } from 'vue'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<Donation> {
  const tableCols = [
    {
      title: '预览图',
      type: {
        module: 'imageUrl',
        borderRadius: 0,
        previewWidth: 50
      },
      key: 'imageUrl',
      width: 200
    },
    {
      title: '村庄',
      width: 300,
      render: (h: any, params: any) => {
        return h('div', params.row.village.name)
      }
    },
    {
      title: '项目名称',
      key: 'name',
      width: 300
    },
    {
      title: '项目说明',
      type: {
        module: 'textarea',
        summary: 20
      },
      key: 'effect'
    },
    {
      title: '创建时间',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD'
      },
      key: 'createTime',
      width: 200
    }
  ]

  const actions: any = [{
    name: 'edit',
    title: '编辑',
    onClick: (dataItem: Donation) => {
      view.onEditItem(dataItem)
    }
  }]

  return {
    tableCols,
    actions
  }
}
